import { ManagementEvent } from "@interfaces/management";

interface RawData {
  data: {
    success: boolean;
    reason?: string | null;
  };
}

export function transformManagementEvent(raw: unknown): ManagementEvent {
  const data = (raw as RawData).data;

  return {
    success: data.success,
    reason: data.reason || null,
  };
}

